import { useNavigate } from 'react-router-dom';

export const useNavigation = () => {
    const navigate = useNavigate();

    return {
        goToHome: () => navigate('/'),
        goToEURegulation: () => navigate('/eu_regulation'),
        goToMission: () => navigate('/mission'),
        goToSupport: () => navigate('/support'),
        goToAboutUs: () => navigate('/about_us'),
        goToPrivacyPolicy: () => navigate('/privacy_policy'),
        goToAppPermission: () => navigate('/app_permission'),
        goToConfidentiality: () => navigate('/confidentiality_agreement'),
        goToTermOfUse: () => navigate('/terms_of_use'),
        goToContactUs: () => navigate('/contact_us'),
        goToDonate: () => navigate('/donate-form'),
        goToDoodle: () => window.open('/doodle', '_blank', 'noopener,noreferrer'),
    };
};
